/**
 * CommandPalette Types
 *
 * @module command-palette/types
 * @version 1.0
 * @updated 2026-04-27
 */

import type { ReactElement } from 'react';

/**
 * Grupo de una acción rápida.
 * Controla el encabezado de sección en la paleta.
 */
export type CommandActionGroup = 'actions' | 'modules' | 'modes';

/**
 * Orden de renderizado de grupos y sus labels.
 */
export const COMMAND_GROUP_ORDER: CommandActionGroup[] = ['actions', 'modules', 'modes'];

export const COMMAND_GROUP_LABELS: Record<CommandActionGroup, string> = {
  actions: 'Acciones',
  modules: 'Módulos',
  modes:   'Modos',
};

/**
 * Acción rápida local — no requiere API.
 * Filtrada por label, description y keywords.
 */
export interface CommandAction {
  id: string;
  label: string;
  description?: string;
  /** Palabras clave adicionales para filtrado por query */
  keywords: string[];
  icon: ReactElement;
  group: CommandActionGroup;
  onExecute: () => void;
  disabled?: boolean;
  /** Razón mostrada como tooltip cuando disabled = true */
  disabledReason?: string;
}
